import {destroyCarousel, initCarousel} from './carousel';
import {initMimage} from './mimage';
import {selectToggle} from './form';

export function renderComponents(){
  initCarousel();
  initMimage();
  selectToggle();
}

export {
  destroyCarousel
};
